import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardHeader, CardTitle, CardContent, Button } from '@/components/ui';
import { ExternalLink } from 'lucide-react';

export function GoogleAccountManagement() {
  const { t } = useTranslation();
  
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("profile.googleAccountManagement")}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="mb-4">
          {t("profile.googleAccountDesc")}
        </p>
        <Button
          variant="outline"
          className="flex items-center"
          onClick={() => window.open('https://myaccount.google.com/security', '_blank', 'noopener,noreferrer')}
        >
          {t("profile.googleAccountSecurity")}
          <ExternalLink className="ml-2 h-4 w-4" />
        </Button>
      </CardContent>
    </Card>
  );
}